import React from 'react';
import '98.css';

import Home from './components/Home';
import Projects from './components/Projects';

function App() {
  return (
    <div className="min-h-screen bg-[#000080] p-4 sm:p-10">
      <div className="window max-w-3xl mx-auto w-full">
        <div className="title-bar bg-[#000080]">
          <div className="title-bar-text">visianary.dev</div>
          <div className="title-bar-controls flex justify-end">
            <button aria-label="Minimize"></button>
            <button aria-label="Maximize"></button>
            <button aria-label="Close"></button>
          </div>
        </div>

        <div className="window-body p-4 sm:p-6">
          <Home/>

          <hr className="my-6"/>

          <Projects/>
        </div>
      </div>
    </div>
  );
}

export default App;